import { axiosClient } from "@/api/axios";

export function getUserInfo() {
  return axiosClient.get("/dashboard/manager-cc/user-info");
}

export function getRanking(userActiveRole) {
  return axiosClient.get(`/dashboard/manager-cc/${userActiveRole}/ranking`);
}

export function getAveragePerformance(userActiveRole) {
  return axiosClient.get(`/dashboard/manager-cc/${userActiveRole}/average`);
}

export function getProgress(userActiveRole) {
  return axiosClient.get(`/dashboard/manager-cc/${userActiveRole}/progress`);
}

export function getCorrectAnswersPercentage(userActiveRole) {
  return axiosClient.get(
    `/dashboard/manager-cc/${userActiveRole}/correct-answers-percentage`
  );
}

export function getTeamInfo(userActiveRole) {
  return axiosClient.get(`/dashboard/manager-cc/${userActiveRole}/team-info`);
}

export function getTeamLastTopics(userActiveRole) {
  return axiosClient.get(
    `/dashboard/manager-cc/${userActiveRole}/latest-topics`
  );
}
